// extracted by mini-css-extract-plugin
module.exports = {"progress__outer":"FJProgress_progress__outer__3sgk7","progress__inner":"FJProgress_progress__inner__2NjkK"};